<div class="px-4 py-8 sm:py-24 sm:px-6 lg:px-8 max-w-7xl mx-auto">

  

  

  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-base font-semibold text-gray-900">Customers</h1>
      
    </div>
    <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
      <!-- <button type="button" class="block rounded-md bg-accent px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ">Create Customer</button> -->
    </div>
  </div>
  <div class="">
    <ubc-customer-search (customerWasPicked)="customerPickedFromSearch($event)" (resultsUpdated)="searchResultsUpdated($event)" [disableList]="true"></ubc-customer-search>
  </div>
  <div class="mt-8 flow-root">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div *ngIf="!hasSearchResults" class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <table class="min-w-full divide-y divide-gray-300">
          <colgroup>
            <col class="w-[16.66%]">
            <col class="w-[16.66%]">
            <col class="w-[16.66%]">
            <col class="w-[16.66%]">
            <col class="w-[16.66%]">
            <col class="w-[16.66%]">
            
          </colgroup>
          <thead class="bg-white">
            <tr>
              <th scope="col" (click)="sortBy('name')" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0  cursor-pointer hover:bg-gray-50">
                <div class="flex items-center">
                  <span>Name</span>
                  <span class="ml-2">
                    <svg *ngIf="currentSortField === 'name' && currentSortOrder === 'asc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 4.414l-3.293 3.293a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="currentSortField === 'name' && currentSortOrder === 'desc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 15.586l3.293-3.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </div>
              </th>
              <th scope="col" (click)="sortBy('email')" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900  cursor-pointer hover:bg-gray-50">
                <div class="flex items-center">
                  <span>Email</span>
                  <span class="ml-2">
                    <svg *ngIf="currentSortField === 'email' && currentSortOrder === 'asc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 4.414l-3.293 3.293a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="currentSortField === 'email' && currentSortOrder === 'desc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 15.586l3.293-3.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </div>
              </th>
              <th scope="col" (click)="sortBy('tel')" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900  cursor-pointer hover:bg-gray-50">
                <div class="flex items-center">
                  <span>Phone</span>
                  <span class="ml-2">
                    <svg *ngIf="currentSortField === 'tel' && currentSortOrder === 'asc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 4.414l-3.293 3.293a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="currentSortField === 'tel' && currentSortOrder === 'desc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 15.586l3.293-3.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </div>
              </th>
              <th scope="col" (click)="sortBy('firstAppointmentStartTime')" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900  cursor-pointer hover:bg-gray-50">
                <div class="flex items-center">
                  <span>First Appointment</span>
                  <span class="ml-2">
                    <svg *ngIf="currentSortField === 'firstAppointmentStartTime' && currentSortOrder === 'asc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 4.414l-3.293 3.293a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="currentSortField === 'firstAppointmentStartTime' && currentSortOrder === 'desc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 15.586l3.293-3.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </div>
              </th>
              <th scope="col" (click)="sortBy('lastAppointmentStartTime')" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900  cursor-pointer hover:bg-gray-50">
                <div class="flex items-center">
                  <span>Latest Appointment</span>
                  <span class="ml-2">
                    <svg *ngIf="currentSortField === 'lastAppointmentStartTime' && currentSortOrder === 'asc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 4.414l-3.293 3.293a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="currentSortField === 'lastAppointmentStartTime' && currentSortOrder === 'desc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 15.586l3.293-3.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </div>
              </th>
              <th scope="col" (click)="sortBy('daysSinceLastAppointment')" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900  cursor-pointer hover:bg-gray-50">
                <div class="flex items-center">
                  <span>Since Last Appt</span>
                  <span class="ml-2">
                    <svg *ngIf="currentSortField === 'daysSinceLastAppointment' && currentSortOrder === 'asc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 4.414l-3.293 3.293a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="currentSortField === 'daysSinceLastAppointment' && currentSortOrder === 'desc'" class="h-4 w-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 15.586l3.293-3.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </div>
              </th>
              
            </tr>
          </thead>
        </table>
        <div #tableContainer class="max-h-[70vh] overflow-y-auto" (scroll)="onTableScroll($event)">
          <table class="min-w-full divide-y divide-gray-300">
            <colgroup>
              <col class="w-[16.66%]">
              <col class="w-[16.66%]">
              <col class="w-[16.66%]">
              <col class="w-[16.66%]">
              <col class="w-[16.66%]">
              <col class="w-[16.66%]">
              
            </colgroup>
            <tbody class="divide-y divide-gray-200">
            <tr *ngFor="let customer of customers">
              <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{{ customer.getFullName() }}</td>
              
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 "><a href="mailto:{{ customer.email }}">{{ customer.email }}</a></td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"><a href="{{ customer.tel }}">{{ customer.tel }}</a></td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                <span
                  *ngIf="customer.firstAppointmentId"
                  (click)="openAppointment(customer.firstAppointmentId)"
                >
                  {{ customer.firstAppointmentStartTime | date:'d/M/yy' }}
              </span>
                <br />
                <span class="text-xs" *ngIf="customer.firstAppointmentStartTime">
                  {{ customer.firstAppointmentStartTime | daysAgo }}
                </span>
                <span class="text-xs" *ngIf="!customer.firstAppointmentStartTime">
                  No appointment found
                </span>
              </td>
              

              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                <span
                  *ngIf="customer.lastAppointmentId"
                  (click)="openAppointment(customer.firstAppointmentId)"
                >
                  {{ customer.lastAppointmentStartTime | date:'d/M/yy' }}
                </span>
                <br />
                
                <span class="text-xs" *ngIf="!customer.lastAppointmentStartTime">
                  No appointment found
                </span>
              </td>
              <td class=" px-3 py-4 text-sm text-gray-500"><span *ngIf="customer.daysSinceLastAppointment && customer.daysSinceLastAppointment > -1">{{ customer.daysSinceLastAppointment }} day<span *ngIf="customer.daysSinceLastAppointment > 1">s</span> ago</span></td>

              
            </tr>

            </tbody>
          </table>
          <div *ngIf="isLoading" class="flex justify-center py-4">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-accent"></div>
          </div>
        </div>
      </div>

      <div *ngIf="hasSearchResults" class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <li *ngFor="let customer of customers" class="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow odd:bg-gray-50 hover:bg-gray-100 duration-200 transition-colors ease-in-out">
          <div class="flex w-full items-center justify-between space-x-6 p-6">
            <div class="flex-1 truncate">
              <div class="flex items-center space-x-3">
                <h3 class="truncate text-base font-bold text-gray-900 mb-2">{{customer.getFullName()}}</h3>
                
              </div>
              <table class="text-sm">
                <tr class="pb-1.5">
                  <td class="font-bold text-xs">Email</td>
                  <td>{{ customer.email }}</td>
                </tr>
                <tr class="pb-1.5">
                  <td class="font-bold text-xs">Phone</td>
                  <td>{{ customer.tel }}</td>
                </tr>
                <tr class="pb-1.5">
                  <td class="font-bold text-xs">Appointments</td>
                  <td>{{ customer.appointmentsCount }}</td>
                </tr>
                <tr class="pb-1.5">
                  <td class="font-bold text-xs">Latest Appointment</td>
                  <td><a
                    *ngIf="customer.lastAppointmentId"
                    [href]="'/calendar?appt=' + customer.lastAppointmentId"
                  >
                    {{ customer.lastAppointmentStartTime | date:'d/M/yy' }}
                  </a></td>
                </tr>
                <tr class="pb-1.5">
                  <td class="font-bold text-xs">Horses</td>
                  <td class="text-xs  whitespace-normal">
                    <ng-container *ngFor="let horse of customer.horses; let last = last">
                      {{ horse.name }}<span *ngIf="!last">, </span>
                    </ng-container>
                  </td>
                </tr>
                <ng-container *ngIf="findMatchReason(customer) as reasons">
                  <tr *ngIf="reasons.length > 0" class="pb-1.5">
                    <td class="font-bold text-xs pt-3">Found by</td>
                    <td class="text-xs pt-3" [innerHTML]="reasons.join('<br />')"></td>
                  </tr>
                </ng-container>
              </table>
              
            </div>
            
          </div>
          
        </li>
      
        <!-- More people... -->
      </ul>

    </div>
      
    </div>
  </div>
</div>
